import React from 'react';
import { createRoot } from 'react-dom/client';
import './posthogClient';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { PremiumProvider } from './components/Subscription/PremiumProvider';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PremiumProvider>
        <App />
      </PremiumProvider>
    </Provider>
  </React.StrictMode>
);

